export default "__VITE_ASSET__CP9mHMBt__"